exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-idp {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  margin: 0 0 2em;\n}\n.custom-idp input {\n  flex-grow: 2;\n  margin-right: .5em;\n}\n\n.idp-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: -.25em -.5em;\n}\n.idp {\n  flex: 1 100%;\n  margin: .25em;\n  padding: .75em .5em;\n  border-radius: 10px;\n}\n\n@media all and (min-width: 500px) {\n  .idp {\n    flex: 1 200px;\n  }\n}\n", ""]);

// exports
